import { types } from './actions';

const initialState = {
  showOperatorEntryModal: false,
  showOperatorMergeModal: false,
  showOperatorAddModal: false,
  operator: null,
};

const operatorList = (state = initialState, action) => {
  switch (action.type) {
    case types.OPEN_OPERATOR_EDIT_MODAL: {
      const { payload: operator } = action;
      return {
        ...state,
        showOperatorEntryModal: true,
        operator,
      };
    }
    case types.CLOSE_OPERATOR_EDIT_MODAL: {
      return {
        ...state,
        showOperatorEntryModal: false,
        operator: null,
      };
    }

    case types.OPEN_OPERATOR_MERGE_MODAL: {
      const { payload: operator } = action;
      return {
        ...state,
        showOperatorMergeModal: true,
        operator,
      };
    }
    case types.CLOSE_OPERATOR_MERGE_MODAL: {
      return {
        ...state,
        showOperatorMergeModal: false,
        operator: null,
      };
    }

    case types.OPEN_OPERATOR_ADD_MODAL: {
      return {
        ...state,
        showOperatorAddModal: true,
      };
    }
    case types.CLOSE_OPERATOR_ADD_MODAL: {
      return {
        ...state,
        showOperatorAddModal: false,
        operator: null,
      };
    }
    default:
      return state;
  }
};

export default operatorList;
